import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent {
  @Input() productData: any;
  showDescription = false;

  constructor() {}

  ngOnInit() {
    // console.log(this.product);
  }
}